// extracted by mini-css-extract-plugin
export default {"checkboxradio":"checkboxradio--taVe1"};